import moment from "moment";
// import momentTimezone from "moment-timezone";

// Util for typescript

export const formatToBEDatetime = ({
  date,
  startFormat = "MM/DD/YYYY HH:mm",
  endFormat = "DD/MM/YYYY HH:mm"
}: {
  date?: string | moment.Moment;
  startFormat?: string;
  endFormat?: string;
} = {}) => {
  if (!date) {
    return ""
  }
  let datetime = moment(date, startFormat)
  if (!moment(datetime).isValid()) {
    return ""
  }
  return datetime
    .add(543, "years")
    .format(endFormat);
};

export const convertToThaiDate = ({
  date,
  display,
  options
}: {
  date: string | moment.Moment;
  display?: string;
  options?: Intl.DateTimeFormatOptions;
}): string => {
  let newDate: Date | string;

  if (moment.isMoment(date)) {
    newDate = new Date(date.format("MM/DD/YYYY"));
  } else {
    return date.toString();
  }
  if (display === "time" && newDate instanceof Date) {
    return (
      newDate
        .getHours()
        .toString()
        .padStart(2, "0") +
      ":" +
      newDate
        .getMinutes()
        .toString()
        .padStart(2, "0")
    );
  } else if (display === "monthDate" && newDate instanceof Date) {
    return newDate
      .toDateString()
      .split(" ")
      .slice(1, -1)
      .join(" ");
  } else if (display === "date" && newDate instanceof Date) {
    return newDate.toDateString();
  } else if (display === "localeDate" && newDate instanceof Date) {
    return newDate.toLocaleDateString("th-TH", options);
  } else if (display === "localeDay" && newDate instanceof Date) {
    return newDate.toLocaleDateString("th-TH", {
      weekday: "short"
    });
  } else {
    return newDate.toString();
  }
};

export const convertToBEDate = ({
  date,
  endFormat = "DD/MM/YYYY",
  startFormat = "DD/MM/YYYY"
}: {
  date: string;
  endFormat?: string;
  startFormat?: string;
}): string => {
  // This function only use to convert BE to AD
  let a = moment(date, startFormat)
  let year = a.year() + 543
  let addYearFormat = ""
  if (endFormat.includes("YYYY")) {
    addYearFormat = endFormat.replace("YYYY", `${year}`)
  } else if (endFormat.includes("YY")) {
    addYearFormat = endFormat.replace("YY", `${year % 100}`)
  }

  return a.format(addYearFormat);
};

export const convertToADDate = ({
  date,
  endFormat = "DD/MM/YYYY",
  startFormat = "DD/MM/YYYY"
}: {
  date: string;
  endFormat?: string;
  startFormat?: string;
}): string => {
  // This function only use to convert BE to AD
  return moment(date, startFormat)
    .subtract(543, "years")
    .format(endFormat);
};

// SERIAL
const TIMEZERO = Date.parse(new Date("2017-01-01T00:00:00Z").toString()); // 1483228800000
const SERIAL_ROUNDING = 1000 * 60 * 15;

export const convertBEDateToSerial = ({
  date,
  time,
  format = "DD/MM/YYYY",
}: {
  date: string;
  time?: string;
  format?: string;
}) => {
  let beDate = moment(date, format).format("DD/MM/YYYY").split("/")
  let year = parseInt(beDate[2]);
  let month = parseInt(beDate[1]) - 1;
  let day = parseInt(beDate[0]);
  let hour = 0;
  let min = 0;
  let sec = 0;
  let ms = 0;
  if (time) {
    let timeArr = time.split(":");
    hour = parseInt(timeArr[0]);
    min = timeArr[1] ? parseInt(timeArr[1]) : 0;
    sec = timeArr[2] ? parseInt(timeArr[2]) : 0;
    ms = timeArr[3] ? parseInt(timeArr[3]) : 0;
  }
  let milisec = Date.parse(
    new Date(year, month, day, hour, min, sec, ms).toString()
  );
  return Math.round((milisec - TIMEZERO) / SERIAL_ROUNDING);
};

export const convertSerialToMomentDate = ({ serial }: { serial: number }) => {
  
  // Docker Asia/Bangkok
  return moment(new Date(TIMEZERO + serial * 1000 * 60 * 15))

  // Docker UTC 
  // let a = new Date(TIMEZERO + serial * 1000 * 60 * 15)
  // return momentTimezone(a).tz("Asia/Bangkok")

}

export function formatComma(val: string) {
  return !isNaN(parseFloat(val)) ? parseFloat(val).toFixed(2).toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ",") : val;
}